import * as types from './types';
import { loading } from '../actions';

export const getSitesAction = (getAllSites = false) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITES_LOAD, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `SiteMaster?allSites=${getAllSites}`
      );
      dispatch({
        type: types.GET_SITES,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: types.GET_SITES_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.SITES_LOAD, false));
  };
};

export const getSites = getSitesAction;



// WEBPACK FOOTER //
// ./src/state/sites/actions.js